import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})

export class OrderService {
  urlGateway = environment.api_gateway;

  constructor(
    private http: HttpClient
  ) { }

  listAllByCompany(params = {}): Observable<any> {
    return this.http.post<any>(`${this.urlGateway}/api/orders/list/all/bycompany/v1/`, params);
  }

  listCurrentMonth(params = {}): Observable<any> {
    return this.http.get<any>(`${this.urlGateway}/api/orders/filter/v1/`, { params: params });
  }

  create(params = {}): Observable<any> {
    return this.http.post<any>(`${this.urlGateway}/api/orders/v1/`, params);
  }
}
